import React from "react";
import { Link } from "react-router-dom";
import Njc5Form from "./Njc5Form";

// NJC/MCPJ/5 on the report screen: the NJC form with the current page of rows.
const NjcReport5Table = ({ cases, search, count, header, startIndex = 0 }) => {
  return (
    <div className="table">
      <div className="section-cases-report">
        <span>Relative ages of pending cases</span>
        <div className="no-print">
          <span className="specialaction">
            <Link
              to={`/reports/print/njc5/${search.eventtype || "all"}/${search.judgeid || 0}/${
                search.divisionid || 0
              }/${search.lastdate}`}
              target="_blank"
            >
              Print
            </Link>
          </span>
        </div>
      </div>
      <div style={{ background: "#fff", padding: 16, overflowX: "auto" }}>
        <Njc5Form header={header || {}} rows={cases || []} startIndex={startIndex} showSignatures={false} />
      </div>
    </div>
  );
};

export default NjcReport5Table;
